import { useQuery } from '@tanstack/react-query';

import { getMarketingCampaignsDashboardLink } from '../lib/getMarketingCampaignsDashboardLink';

export function useMarketingCampaignsDashboardQuery(campaignId?: string) {
  return useQuery({
    queryKey: campaignId
      ? ['marketing-campaigns-dashboard-link', 'campaign', campaignId]
      : ['marketing-campaigns-dashboard-link', 'general'],
    queryFn: () => getMarketingCampaignsDashboardLink(campaignId),
    enabled: true,
    // Refetch 1 minute before expiry if time is provided
    staleTime: ({ state }) =>
      Math.max(
        0,
        (state.data?.expiresAt?.getTime() ?? Infinity) - Date.now() - 60_000,
      ),
  });
}
